module.exports = __webpack_public_path__ + "static/media/08(2).82375bb3.jpg";